
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, LookupItemViewModel } from "@tylertech/tyler-api-types";

/**
 * TerminationCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class TerminationCodeLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<LookupItemViewModel[]>> {
        return this.$apiService.sendAuth("ITerminationCodeLookupService/Lookup", pCriteria);
    }
}
